import DumbCheckboxAtom from './CheckboxAtom.dumb';

/* ---------------------------------- Types --------------------------------- */

export interface CheckboxAtomI {
    /** Indicates if an error exists for this field */
    hasError: boolean;

    /** The key from the registration config, to be used as name/id of the field */
    id: string;

    /** Display label for the field */
    label: string;

    /** Whether the field is required to continue */
    required: boolean;

    /** Callback to trigger to update the value managed by the form */
    updateField: (value: boolean) => void;

    /** The current value of the field, managed by the form */
    value: boolean;

    /** Error message to be displayed below each field */
    errorText?: string;
}

/* -------------------------------- Component ------------------------------- */

const CheckBoxAtom = ({
    hasError,
    id,
    label,
    required,
    updateField,
    value,
    errorText,
}: CheckboxAtomI) => (
    <DumbCheckboxAtom
        hasError={hasError}
        id={id}
        label={label}
        required={required}
        updateField={updateField}
        value={value}
        errorText={errorText}
    />
);

/* --------------------------------- Export --------------------------------- */

export default CheckBoxAtom;
